import { render, staticRenderFns } from "./nfcPage.vue?vue&type=template&id=e4400ad0&scoped=true&"
import script from "./nfcPage.vue?vue&type=script&lang=js&"
export * from "./nfcPage.vue?vue&type=script&lang=js&"
import style0 from "./nfcPage.vue?vue&type=style&index=0&id=e4400ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4400ad0",
  null
  
)

export default component.exports